import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, isRef as _isRef, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-1" }
const _hoisted_2 = { class: "w-6 mr-3" }
const _hoisted_3 = { class: "w-full p-input-icon-left mb-3" }
const _hoisted_4 = {
  key: 1,
  class: "overflow-y-scroll scrollbar max-height"
}
const _hoisted_5 = { class: "flex align-items-center mb-2" }
const _hoisted_6 = { class: "alert-red mr-2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "p-2 surface-100 mb-3 border-round-sm"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 3,
  class: "p-2 surface-100 mb-3 border-round-sm"
}
const _hoisted_11 = {
  key: 0,
  class: "w-6 p-3 bg-primary-100 border-round-lg"
}

import { computed, onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useAttendanceStore, useOrganizationStore } from '@/store';
import { StudentAttendanceInterface } from '@/types';
import AutoComplete from 'primevue/autocomplete';
import Divider from 'primevue/divider';
import InputNumber from 'primevue/inputnumber';
import OverlayPanel from 'primevue/overlaypanel';
import AttendanceChart from './AttendanceChart.vue';
import StudentPercentage from './StudentPercentage.vue';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'LowAttendance',
  setup(__props) {

const AttendanceStore = useAttendanceStore();
const organizationStore = useOrganizationStore();
const { lowAttendance, outOfLowAttendance, lowAttendanceThreshold, allPercentage, loading, filteredStudent } =
  storeToRefs(AttendanceStore);

const oldLowAttendanceThreshold = ref(lowAttendanceThreshold.value);
const students = computed(() => [...lowAttendance.value, ...outOfLowAttendance.value]);
const filteredStudents = ref(students.value);
const { organizationsIdsSelected } = storeToRefs(organizationStore);
const studentSelectedKey = ref('');

onMounted(() => {
  updateStudentsLowAttendance();
});

const updateStudentsLowAttendance = () => {
  filteredStudents.value = students.value;
};

const updateThreshold = async () => {
  if (oldLowAttendanceThreshold.value === lowAttendanceThreshold.value) return;

  await AttendanceStore.getLowAttendance(lowAttendanceThreshold.value, organizationsIdsSelected.value);
  updateStudentsLowAttendance();
};

const onStudentSelected = (student: StudentAttendanceInterface, key: string) => {
  if (key === studentSelectedKey.value || key === '') {
    studentSelectedKey.value = '';
    filteredStudent.value = null;
    return;
  }
  filteredStudent.value = student;
  studentSelectedKey.value = key;
};

const searchStudent = (event) => {
  if (event.query.trim().length < 1) {
    return;
  }

  filteredStudents.value = students.value.filter((student: StudentAttendanceInterface) => {
    return student.full_name.toLowerCase().search(event.query.toLowerCase()) >= 0;
  });
};

watch(
  () => organizationsIdsSelected.value,
  () => {
    updateThreshold();
  },
);

watch(filteredStudent, () => {
  if (filteredStudent.value?.id) {
    AttendanceStore.getAttendanceResults(
      filteredStudent.value?.id,
      filteredStudent.value?.full_name,
      organizationsIdsSelected.value,
    );
    studentSelectedKey.value = `k${filteredStudent.value.id}`;
    return;
  }
  AttendanceStore.useCloneResults();
  studentSelectedKey.value = '';
});

const thresholdOverlay = ref();
const openThresholdOverlay = (Event: Event) => {
  thresholdOverlay.value.toggle(Event);
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconField, { "icon-position": "left" }, {
          default: _withCtx(() => [
            _createVNode(_component_InputIcon, {
              class: "p-input-icon-left",
              style: {"z-index":"100"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  name: "search",
                  class: "text-lg"
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(AutoComplete), {
              modelValue: _unref(filteredStudent),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(filteredStudent) ? (filteredStudent).value = $event : null)),
              class: "autocomplete w-full",
              "input-class": "w-full",
              suggestions: filteredStudents.value,
              placeholder: "Search Students",
              "min-length": 2,
              field: "full_name",
              "data-key": "id",
              onComplete: _cache[1] || (_cache[1] = ($event: any) => (searchStudent($event)))
            }, null, 8, ["modelValue", "suggestions"])
          ]),
          _: 1
        })
      ]),
      (_unref(can)([_unref(PERMISSIONS).DASHBOARD_OVERVIEW_ATTENDACE_WIDGET_PERCENTAGE_VIEW]))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["flex align-items-center justify-content-between p-1 border-round-lg surface-100 cursor-pointer", { 'bg-primary-100': !_unref(filteredStudent)?.id, raised: _unref(filteredStudent)?.id }])
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(["w-full flex align-items-center justify-content-between p-1 font-bold border-round-md", { 'bg-primary-100': !_unref(filteredStudent)?.id }]),
              style: {"height":"28px"},
              onClick: _cache[2] || (_cache[2] = () => onStudentSelected(null, ''))
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "All", -1)),
              _createElementVNode("span", null, _toDisplayString(_unref(allPercentage)) + "%", 1)
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_unref(Divider)),
      (_unref(can)([_unref(PERMISSIONS).DASHBOARD_OVERVIEW_ATTENDACE_WIDGET_PERCENTAGE_VIEW]))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, "Low Attendance (<" + _toDisplayString(_unref(lowAttendanceThreshold)) + "%)", 1),
              _createVNode(_component_Icon, {
                name: "edit",
                class: "text-black-alpha-20 cursor-pointer text-sm",
                onClick: openThresholdOverlay
              }),
              _createVNode(_unref(OverlayPanel), {
                ref_key: "thresholdOverlay",
                ref: thresholdOverlay,
                class: "p-3",
                onHide: _cache[4] || (_cache[4] = ($event: any) => (updateThreshold()))
              }, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mb-2" }, "Threshold for \"Low Attendance\" Warning", -1)),
                  _createVNode(_unref(InputNumber), {
                    modelValue: _unref(lowAttendanceThreshold),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(lowAttendanceThreshold) ? (lowAttendanceThreshold).value = $event : null)),
                    "show-buttons": "",
                    "button-layout": "horizontal",
                    suffix: " %",
                    min: 0,
                    max: 100,
                    step: 1,
                    "increment-button-icon": "pi pi-plus",
                    "decrement-button-icon": "pi pi-minus"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 512)
            ]),
            (_unref(lowAttendance).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lowAttendance), (student) => {
                    return (_openBlock(), _createBlock(StudentPercentage, {
                      key: `k${student.id}`,
                      skey: `k${student.id}`,
                      student: student,
                      selected: studentSelectedKey.value === `k${student.id}`,
                      "low-attendance": true,
                      onStudentSelected: onStudentSelected
                    }, null, 8, ["skey", "student", "selected"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_8, "No students with low attendance")),
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-md text-gray-600 mb-2" }, "Students with good attendance", -1)),
            (_unref(outOfLowAttendance).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(outOfLowAttendance), (student) => {
                    return (_openBlock(), _createBlock(StudentPercentage, {
                      key: `k${student.id}`,
                      skey: `k${student.id}`,
                      student: student,
                      selected: studentSelectedKey.value === `k${student.id}`,
                      "low-attendance": false,
                      onStudentSelected: onStudentSelected
                    }, null, 8, ["skey", "student", "selected"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_10, "No students with good attendance"))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(can)([_unref(PERMISSIONS).DASHBOARD_OVERVIEW_ATTENDACE_WIDGET_DETAIL_VIEW]))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(AttendanceChart),
          (!_unref(loading) && _unref(filteredStudent)?.id && _unref(can)([_unref(PERMISSIONS).PERSON_LOGS_INDEX]))
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: `/user/${_unref(filteredStudent).id}/activity`,
                class: "flex align-items-center font-bold no-underline mt-6"
              }, {
                default: _withCtx(() => [
                  _cache[8] || (_cache[8] = _createElementVNode("p", {
                    class: "text-md mr-2 cursor-pointer",
                    style: {"color":"#078888"}
                  }, "See Details", -1)),
                  _createVNode(_component_Icon, {
                    name: "arrow_forward",
                    style: {"color":"#8bcfcf"}
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})